import React from 'react'
import styled from 'styled-components'
import resume from '../img/resume.jpg'

function ImgSection() {
    return (
        <ImgSectionStyled>
            <div className="left-content">
                <img src={resume} alt="resume" />
            </div>
            <div className="right-content">
                <h4>Hi, I'm
                    <span> Om Anand Pandey
                    </span></h4>
                <p className="paragraph">
                    I'm a fourth-year B.Tech (CSE) student from SRM Institute of Science and Technology, Chennai. I'm working towards my aim to be a professional developer, I'm good in Web-Development and always try to do new things related to the technical domain. I'm one who always tries to grab opportunities to learn that falls in my way. Highly focused and eager to leverage the in-depth knowledge of high-end technical skills. </p>
                <div className="about-info">
                    <div className="info-title">
                        <p>Full Name</p>
                        <p>Age</p>
                        <p>Nationality</p>
                        <p>Languages</p>
                        <p>Location</p>
                    </div>
                    <div className="info">
                        <p>: Om Anand Pandey</p>
                        <p>: 21</p>
                        <p>: Indian</p>
                        <p>: English, Hindi, French</p>
                        <p>: Chennai, India</p>
                    </div>
                </div>
                <SecondaryButtonStyled href='Resume.pdf' download="Om's Resume">Download Resume</SecondaryButtonStyled>
            </div>
        </ImgSectionStyled>
    )
}

const ImgSectionStyled = styled.div`
    margin-top: 5rem;
    display: flex;
      @media screen and (max-width:1000px)
      {
          flex-direction: column;
          .left-content{
             margin-bottom: 2rem;
          }
      }

    .left-content{
        width:100%;
        img{
            width: 90%;
            object-fit:cover;
        }
    }
    .right-content{
        h4{
            font-size: 2rem;
            color:var(--white-color);
            span{
                font-size: 2rem;
            }
        }
        .paragraph{
            padding:1rem 0;
        }
        .about-info{
            padding-bottom: 1.4rem;
            display: flex;
            .info-title{
                padding-right: 3rem;
                p{
                    font-weight: 600;
                }
            }
            .info-title, .info{
                p{
                    padding: .3rem 0;
                }
            }
        }
    }
`;


const SecondaryButtonStyled = styled.a`
   background-color: var(--primary-color);
  padding: 0.8rem 2.5rem;
  color: white;
  cursor: pointer;
  display: inline-block;
  font-size: inherit;
  text-transform: uppercase;
  position: relative;
  &::after {
    content: "";
    position: absolute;
    width: 0;
    height: 0.2rem;
    transition: all .4s ease-in-out;
    left:0;
    bottom: 0;
    opacity: .7;
  }
  &:hover::after {
    width: 100%;
    background-color: var(--white-color);
  }
`;

export default ImgSection
